// Historical wire values only. Product code and session instructions use Match.
// Keep this boundary small; do not use these names for current capabilities.

export const MATCH_ROUTE_ALIASES = Object.freeze([
  { source: '/research', destination: '/match/map' },
  {
    "source": "/api/connect",
    "destination": "/api/match"
  },
  {
    "source": "/api/pi",
    "destination": "/api/match/workflows"
  },
  {
    "source": "/api/data-research",
    "destination": "/api/match/benchmarks"
  },
  {
    "source": "/api/pi/clients",
    "destination": "/api/match/clients"
  },
  {
    "source": "/api/pi/longlist",
    "destination": "/api/match/longlist"
  },
  {
    "source": "/api/pi/pamp",
    "destination": "/api/match/call-pair"
  },
  {
    "source": "/api/pi/prospects",
    "destination": "/api/match/prospects"
  },
  {
    "source": "/api/pi/skill-log",
    "destination": "/api/match/skill-log"
  },
  {
    "source": "/api/pi/lazy",
    "destination": "/api/match/sessions"
  },
  {
    "source": "/api/pi/enrichment",
    "destination": "/api/match/enrichment"
  },
  {
    "source": "/api/pi/pamp-stats",
    "destination": "/api/match/call-stats"
  },
  {
    "source": "/api/cron/connect-pairs",
    "destination": "/api/cron/match-pairs"
  }
].map(Object.freeze));

export function canonicalMatchHash(hash) {
  return String(hash || '').replace(/^#(?:pi|director)$/, '#match-calls').replace(/^#new-leads$/, '#match-leads').replace(/^#connect(?=-|$)/, '#match');
}

export const MATCH_LIST_ID_SQL = "(id LIKE 'cl-match-%' OR id LIKE 'cl-pi-%')";
export function matchListNames(jobName) {
  return [`Match, ${jobName}`.slice(0, 80), `PI, ${jobName}`.slice(0, 80)];
}

// Accept requests from a browser that was open before the release.
export function matchSearchRequest(body) {
  if (!body || typeof body !== 'object') return {};
  const { automatch, ...canonical } = body;
  return { ...canonical, matchRanking: Object.hasOwn(canonical, 'matchRanking') ? canonical.matchRanking : automatch };
}

const MATCH_STORAGE_ALIASES = Object.freeze({
  'pb-match-selection': 'pb-research-sel',
  'pb-pane.match.panel': 'pb-pane.research.panel',
  'match-focus': 'pi-focus',
  'match-lazy-session': 'pi-lazy-session',
});
export function readMatchStorage(storage, key) {
  const current = storage.getItem(key);
  if (current !== null) return current;
  const oldKey = MATCH_STORAGE_ALIASES[key];
  if (!oldKey) return null;
  const previous = storage.getItem(oldKey);
  if (previous !== null) {
    try {
      storage.setItem(key, previous);
      storage.removeItem(oldKey);
    } catch { /* Retain the readable preference if storage is full or blocked. */ }
  }
  return previous;
}

export const MATCH_MAP_LEGACY_PATHS = Object.freeze(['/automatch', '/automatch/', '/map', '/map/']);
export function matchMapHost(env = {}) {
  return (env.MATCH_HOST || env.RESEARCH_HOST || 'research.pearsonapp.com').toLowerCase();
}
export function isMatchMapHost(hostname) {
  return /^(?:research|match)\./.test(String(hostname || ''));
}

export function isMatchActor(name) {
  return name === 'Match' || name === 'Research';
}

export function matchWorkflowRequest(body) {
  if (!body || typeof body !== 'object') return {};
  const lane = (value) => value === 'connect' ? 'match' : value === 'pamp' ? 'calls' : value;
  return { ...body, ...(body.lane != null ? { lane: lane(body.lane) } : {}),
    ...(body.evidence && typeof body.evidence === 'object' && !Array.isArray(body.evidence)
      ? { evidence: { ...body.evidence, ...(body.evidence.lane != null ? { lane: lane(body.evidence.lane) } : {}) } } : {}),
  };
}

export const MATCH_SESSION_LANE = 'lazy';
export const MATCH_SESSION_STORAGE_KEY = 'match-lazy-session';
